<template>
  <tbody>
  <tr class="clickable" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span
          v-if="entity.global"
          class="lock"
          :title="$gettext('Systémovou skupinu nelze editovat')"
          v-translate>S
			</span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <span class="lock" v-if="!$_updateActionAllowed" 	:title="'Systémovou skupinu nelze editovat' | translate" v-translate>Zamčeno</span>
    <td :data-th="'Název skupiny' | translate">
      {{ entity.name }}
    </td>
    <td :data-th="'Kód skupiny' | translate">
      {{ entity.code }}
    </td>
    <td :data-th="'Počet přiřazených uživatelů' | translate">
      {{ entity.user_count }}
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_createActionAllowed"
            class="btn btn_action btn_grey btn_duplicate"
            :title="'Duplikovat' | translate"
            @click.prevent.stop="duplicateEntity">
          <translate class="translate">Duplikovat</translate>
        </a>
        <a
            v-if="!entity.global && $_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteRoleGroup">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
  </tbody>
</template>

<script>
import rowActions from "@/components/mixins/row-actions";

export default {
  name: "RoleGroupsRow",
  mixins: [rowActions],
  props: {
    entity: Object,
  },
  methods: {
    emitDeleteRoleGroup() {
      this.$emit('deleteRoleGroup', String(this.entity.id));
    },
    duplicateEntity() {
      this.$router.push({name: 'roleGroupsNew', query: {duplicate: this.entity.id,}});
    },
    goToDetail(e, id) {
      this.$router.push({name: 'roleGroupsDetailBasicInfo', params: {id: id}});
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/roleGroups/RoleGroupsRow.vue